import { render, staticRenderFns } from "./PeiFuBiaoZhunView.vue?vue&type=template&id=d07b476e&scoped=true"
import script from "./PeiFuBiaoZhunView.vue?vue&type=script&lang=js"
export * from "./PeiFuBiaoZhunView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07b476e",
  null
  
)

export default component.exports